import { IAddon } from "../models/Addon";

class AddonStore {
    constructor(private _model: IAddon) {
    }

    public get display_name(): string { return this._model.display_name; }
    public get purchased_on_date(): string { return this._model.created_at; }
    public get updated_on_date(): string | undefined { return this._model.updated_at; }

    public get price(): number {
        let total = 0;
        this._model.features.forEach(f => {
            total += Number(f.feature_price);
        });
        return total;
    }
}

export default AddonStore;
